import { gql } from "@apollo/client"

export const TerminationFields = gql`
  fragment TerminationFields on Termination {
    id
    state
    proposedDate
    note
    lastPayment
    lastPaymentAmount
    lastPaymentCurrencyCode
    reason
    onLeave
    engagement {
      id
      engagementType
      company {
        id
        name
      }
    }
    file {
      base64
      byteSize
      contentType
      createdAt
      filename
      title
      url
    }
  }
`
